import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box, Typography, } from '@mui/material';
import AssetImage from '../asset/AssetImage';
const ParaWithImage = ({ text, asset, courseItem }) => (_jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, sm: 12, children: text && (_jsx(Box, { className: "slate", sx: { p: 2, pt: 0 }, children: _jsx(Typography, { variant: "h4", component: "p", dangerouslySetInnerHTML: { __html: text }, className: "description" }) })) }), _jsx(Grid, { item: true, sm: 12, sx: {
                width: '100%',
            }, children: _jsx(AssetImage, { asset: asset, size: "thumb400w", customStyle: {
                    maxHeight: courseItem.type === 'audio' ? '465px' : '540px',
                    maxWidth: '100%',
                } }) })] }));
export default ParaWithImage;
//# sourceMappingURL=paraWithImage.js.map